import { ContentItem } from 'kentico-cloud-delivery';

import get from 'lodash/get';

export default class ShareLink extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
    });
  }

  get marketName() {
    return get(this, '_market.value[0].name', '');
  }

  get marketCodeName() {
    return get(this, '_market.value[0].codename', '');
  }

  get link() {
    return get(this, '_link.value', '');
  }

  get id() {
    return get(this, 'system.id', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/ShareLink.model.js